export default "__VITE_ASSET__Ds6cY3DJ__"